module.exports = __webpack_public_path__ + "site/img/121.254f4e93.jpg";